import { makeAxiosClient } from './secondStepClient'

export const makeSharedEndpoints = _api => {
  return {
    getSetupLicensesForUser: async () => _api.get(`licenses/me`),

    getUserAccess: async () => {
      return _api.get('access/me')
    },

    getUserLicenses: async () => {
      return _api.get(`licenses/me`)
    },

    getUserSites: async () => {
      return _api.get('sites/me')
    },

    getValidatePak: async pakNumber => {
      const body = {
        pakNumber,
      }
      return _api.post(`pak/validate`, body)
    },

    getValidateAccessCode: accessCode => {
      const body = {
        accessCode,
      }
      return _api.post(`access/codes`, body)
    },

    postAcceptUserAgreement: async documentId => {
      const body = {
        documentId,
      }
      return _api.post(`useragreement/me`, body)
    },

    postAccessCode: accessCode => {
      const body = {
        accessCode,
        processCode: true,
      }
      return _api.post(`access/codes`, body)
    },

    postPakNumber: async pakNumber => {
      const body = {
        pakNumber,
      }
      return _api.post(`userpak/me`, body)
    },

    updateSitePacingDates: async (siteId, programAccessCode, pacingUpdate) => {
      return _api.post(
        `sites/${siteId}/pacing/${programAccessCode}`,
        pacingUpdate,
      )
    },

    updateSitePreferences: async (siteId, sitePreferences) => {
      return _api.put(`sites/${siteId}/preferences`, sitePreferences)
    },

    updateSiteUserPreferences: async (siteId, sitePreferences) => {
      const url = `sites/${siteId}/siteusers/preferences`
      return _api.put(url, sitePreferences)
    },

    updateMspOptInSettings: async mspOptInArr => {
      return _api.patch(`sites/adminpreferences`, mspOptInArr)
    },
  }
}

export const buildClient = ({ baseApiAddress, extend }) => {
  const _api = makeAxiosClient(baseApiAddress)
  const shared = makeSharedEndpoints(_api)
  const extended = typeof extend === 'function' ? extend(shared, _api) : shared
  return { baseApiAddress, ...extended }
}
